<template>
    <div />
</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import type { TMenu } from '../types/menuTypes';
    import type { IMenuFooter } from '../types/menuFooterTypes';

    const props = defineProps<{
        menuData: TMenu,
        mobileMenuFooterData: IMenuFooter,
    }>();

    const menuStore = useMenuStore();

    const pushDataToStore = () => {
        menuStore.updateMenuData(props.menuData);
        menuStore.updateMobileFooterData(props.mobileMenuFooterData);
    };

    onMounted(() => {
        pushDataToStore();
    });
</script>
